import { Fetcher } from '../helpers/Fetcher'

const { REACT_APP_BASE_URL:Base_URL } = process.env;

export const EstimationApi = (credentials:{}) => {
    return Fetcher(`${Base_URL}`,'POST',credentials)
}

export const convertCurrency = (estimation:number) => {
    return Fetcher(`https://api.apilayer.com/exchangerates_data/convert?to=USD&from=NGN&amount=${estimation}`,'GET',{},true)
}
